import React from 'react';

const OnlineOffline = () => {
  const totalDevices = 3;
  const onlineDevices = 1;
  const offlineDevices = 2;

  return (
    <div style={{
      background: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)',
      border: '1px solid rgba(16, 185, 129, 0.2)',
      borderRadius: '12px',
      padding: '24px',
      transition: 'all 0.3s ease',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      cursor: 'pointer',
      maxWidth: '400px',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-6px)';
      e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.15)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
    }}>
      
      {/* Total Devices */}
      <div style={{ marginBottom: '20px' }}>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center',
          gap: '16px'
        }}>
          <span style={{ 
            fontSize: '4rem', 
            color: '#065f46', 
            fontWeight: 700,
            lineHeight: 1
          }}>
            {totalDevices}
          </span>
          <span style={{ 
            color: '#047857', 
            fontWeight: 600,
            fontSize: '1.25rem'
          }}>
            Total Devices
          </span>
        </div>
      </div>

      {/* Divider */}
      <div style={{ 
        height: '1px', 
        background: 'rgba(16, 185, 129, 0.2)', 
        margin: '20px 0' 
      }} />

      {/* Status Chips */}
      <div style={{ 
        display: 'flex', 
        gap: '12px'
      }}>
        <div style={{
          flex: 1,
          background: '#86efac',
          color: '#14532d',
          padding: '12px 16px',
          borderRadius: '16px',
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          fontSize: '1rem'
        }}>
          <span style={{ fontSize: '1.25rem' }}>✓</span>
          Online: {onlineDevices}
        </div>
        
        <div style={{
          flex: 1,
          background: '#fecaca',
          color: '#991b1b',
          padding: '12px 16px',
          borderRadius: '16px',
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          fontSize: '1rem'
        }}>
          <span style={{ fontSize: '1.25rem' }}>✕</span>
          Offline: {offlineDevices}
        </div>
      </div>
    </div>
  );
};

export default OnlineOffline;